import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { guides } from '../content/guides';

export const ReadingPage = styled.div`
  max-width: 1180px; margin: 0 auto; padding: clamp(3rem, 6vw, 6rem) 1.5rem;
  .eyebrow { color: #0f766e; font-size: .78rem; letter-spacing: .13em; text-transform: uppercase; font-weight: 750; margin-bottom: 1rem; }
  h1 { color: #1c124a; font-size: clamp(2.35rem, 5.5vw, 4rem); line-height: 1.08; letter-spacing: -.04em; max-width: 900px; margin-bottom: 1.5rem; }
  .lede { max-width: 720px; font-size: 1.15rem; color: #5b566e; line-height: 1.8; }
  .guide-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1.5rem; margin-top: 3rem; }
  .guide-card { padding: clamp(1.5rem, 3vw, 2.5rem); border: 1px solid #ded8ce; border-radius: 16px; background: #fffdf8; }
  .guide-card img { display: block; width: 100%; height: auto; aspect-ratio: 1200 / 630; border-radius: 8px; margin-bottom: 1.25rem; }
  .guide-card h2 { font-size: 1.65rem; line-height: 1.25; margin: .7rem 0 1rem; }
  .guide-card h2 a { color: #1c124a; }
  .guide-card p { color: #5b566e; }
  .guide-card .read-link { display: inline-flex; align-items: center; min-height: 44px; margin-top: 1rem; color: #0f766e; font-weight: 700; text-decoration: underline; text-underline-offset: 4px; }
  .guide-category { color: #0f766e; font-size: .8rem; font-weight: 700; }
  @media(max-width: 700px) { .guide-grid { grid-template-columns: 1fr; } }
`;

export default function BlogPage() {
  return <ReadingPage>
    <p className="eyebrow">The Pasur notebook</p>
    <h1>A little knowledge.<br />A better hand.</h1>
    <p className="lede">Pasur guides for your next game: learn the rules, understand the valuable cards, and work through the choices that make a good capture.</p>
    <div className="guide-grid">{guides.map(guide => <article className="guide-card" key={guide.slug}>
      <Link to={`/blog/${guide.slug}/`} tabIndex={-1} aria-hidden="true"><img src={`/images/guides/${guide.slug}.png`} width="1200" height="630" alt="" loading="lazy" /></Link>
      <span className="guide-category">{guide.category} · {guide.readTimeMinutes} min read</span>
      <h2><Link to={`/blog/${guide.slug}/`}>{guide.title}</Link></h2>
      <p>{guide.description}</p>
      <Link className="read-link" to={`/blog/${guide.slug}/`}>Read the guide <span aria-hidden="true"> &nbsp;↗</span></Link>
    </article>)}</div>
    <p style={{ marginTop: '2rem' }}>New to the game? Start with the <Link to="/rules">Pasur rules reference</Link>.</p>
  </ReadingPage>;
}
